import React from "react";

const NextButton = ({ step = 1, enabled = true, onClick }) => {
  const getLabel = () => {
    if (step === 0) return "처음으로 돌아가기";
    if (step === 1) return "다음";
    return "인증완료";
  };

  return (
    <div>
      <div style={{ height: 20 }} />
      <button
        onClick={enabled ? onClick : undefined}
        className={`next-btn ${enabled ? "enabled" : "disabled"}`}
        disabled={!enabled}
      >
        {getLabel()}
      </button>
      <div style={{ height: 8 }} />
    </div>
  );
};

export default NextButton;
